import { createFileRoute, notFound } from '@tanstack/react-router'

import { DebugPage } from '@/features/debug/DebugPage'

export const Route = createFileRoute('/debug')({
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw notFound()
  },
  component: DebugPage,
})
